export enum TypeAccount {
    AHORROS = 'AHORROS',
    CORRIENTE = 'CORRIENTE'
}
